import Mapper from '../mapper/mapper.json';
import * as log from './log';
export default function useComponentBuilder(index, nextStep, authenticatorListing) {
  const mapper = Mapper;
  const list = authenticatorListing;
  const authType = index == 0 ? 'primary' : "";
  let configItem = [];
  mapper.map((item, idx) => {
    configItem[idx] = item.authsdk;
  });
  const getLoadComponent = authValue => {
    return mapper.filter(item => item.authsdk == authValue);
  };
  const getAuth = listItems => {
    let step = nextStep.toLowerCase();
    return listItems.includes(step) ? step : null;
  };
  let toLoadComponent = {};
  let auth = [];
  let arrayList = [];
  try {
    switch (authType) {
      case 'primary':
        auth = list.primary[0];
        let componentList = getLoadComponent(auth);
        toLoadComponent = componentList[0];
        break;
      default:
        auth = getAuth(configItem);
        arrayList = auth != null ? getLoadComponent(auth) : null;
        toLoadComponent = arrayList[0];
        break;
    }
    return toLoadComponent;
  } catch (error) {
    log.info("NextStep Auth Component is not available");
  }
}